export class TimeOfDay {
  hour: number;
  minute: number;

  constructor(hour: number, minute: number) {
    this.hour = hour;
    this.minute = minute;
  }

  /**
   * Returns an ISO string representing today's date with this TimeOfDay's 
   * hours and minutes, adjusted so the ISO string "reads" as local time.
   * 
   * e.g. 12:00 in GMT+1 returns "2026-02-04T12:00:00.000"
   * The built-in function Date.toISOString() would instead return "2026-02-04T11:00:00.000Z".
   */
  public toLocalISOString(): string {
    const date = new Date();
    date.setHours(this.hour, this.minute, 0, 0);
    // Calculate offset (e.g., -60 minutes in Germany)
    const MIN_TO_MS = 60000;
    const tzOffset = date.getTimezoneOffset() * MIN_TO_MS;

    // 1. Shift the date manually by the offset so outputs the local hour/minute
    // 2. .slice(0, -1) removes the 'Z' suffix to indicate this is a local time
    const localISOTime = new Date(date.getTime() - tzOffset).toISOString().slice(0, 19);

    return localISOTime;
  }

  public equals(other: TimeOfDay | null | undefined): boolean {
    if (!other || !(other instanceof TimeOfDay)) {
      return false;
    }
    return this.hour === other.hour && this.minute === other.minute;
  }
}